import { Checkbox, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@shigo-ui/ui';

import { dashboardT } from '../../../../lib/messages';
import {
  companyName,
  domainLabel,
  hasItemId,
  itemId,
  toRecords,
  toggleExcludedItem,
  type UnknownItem,
} from './SelectedSupplyTables.helpers';
import { ManagedSelectionTable } from './ManagedSelectionTable';
import { managedSelectionTableClassNames } from './ManagedSelectionTable.styles';

export function SelectedDomainsTable({ items }: { items: unknown[] }) {
  return <DomainsLiteTable items={toRecords(items)} selectable={false} />;
}

export function DomainsLiteTable({
  excludedItems = [],
  items,
  selectable,
  onExcludedItemsChange,
}: {
  excludedItems?: unknown[] | undefined;
  items: UnknownItem[];
  selectable: boolean;
  onExcludedItemsChange?: ((items: unknown[]) => void) | undefined;
}) {
  if (!items.length) {
    return <p className="text-muted-foreground text-sm">{dashboardT('targeting.noDomainsData')}</p>;
  }

  return (
    <ManagedSelectionTable aria-label={dashboardT('madBuy.common.domains')}>
      <TableHeader className={managedSelectionTableClassNames.header}>
        <TableRow className={managedSelectionTableClassNames.row}>
          <TableHead className={managedSelectionTableClassNames.head}>
            {dashboardT('madBuy.common.url')}
          </TableHead>
          <TableHead className={managedSelectionTableClassNames.head}>
            {dashboardT('madBuy.common.company')}
          </TableHead>
          {selectable ? (
            <TableHead className={`${managedSelectionTableClassNames.head} w-28`}>
              {dashboardT('targeting.included')}
            </TableHead>
          ) : null}
        </TableRow>
      </TableHeader>
      <TableBody>
        {items.map((domain) => {
          const checked = !hasItemId(excludedItems, itemId(domain));
          return (
            <TableRow key={itemId(domain)} className={managedSelectionTableClassNames.row}>
              <TableCell className={`${managedSelectionTableClassNames.cell} font-medium`}>
                {domainLabel(domain)}
              </TableCell>
              <TableCell className={managedSelectionTableClassNames.cell}>
                {companyName(domain)}
              </TableCell>
              {selectable ? (
                <TableCell className={managedSelectionTableClassNames.cell}>
                  <Checkbox
                    checked={checked}
                    aria-label={dashboardT('targeting.includeNamed', {
                      name: domainLabel(domain),
                    })}
                    onCheckedChange={(value) => {
                      onExcludedItemsChange?.(
                        toggleExcludedItem(excludedItems, domain, value !== true),
                      );
                    }}
                  />
                </TableCell>
              ) : null}
            </TableRow>
          );
        })}
      </TableBody>
    </ManagedSelectionTable>
  );
}
